import { render, staticRenderFns } from "./tradeBonusList.vue?vue&type=template&id=9709a818&scoped=true"
import script from "./tradeBonusList.vue?vue&type=script&lang=js"
export * from "./tradeBonusList.vue?vue&type=script&lang=js"
import style0 from "./tradeBonusList.vue?vue&type=style&index=0&id=9709a818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9709a818",
  null
  
)

export default component.exports